export default __webpack_public_path__ + "static/media/PlaceholderPageImage.103cc2d1.svg";